import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./getHeaderOptions";
import logger from "../utils/logger";

const API_ENDPOINT = API_URL + "api/v1";

export const getAllConversations = (data: any, params: any = {}) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get(`${API_ENDPOINT}/whatsapp/conversation`, {
    headers: obj,
    data: data,
    params,
  });
};

export const searchLeads = (term: string) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get(`${API_ENDPOINT}/lead/search`, {
    headers: obj,
    params: {
      search: term,
      page: 1,
      perPage: 15,
    },
  });
};

export const getConversationsFromId = (
  id: string, 
  paginationOptions?: {
    page?: number;
    perPage?: number;
  }
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };

  // ✅ SIMPLE: Only add params if pagination options provided
  const params: any = {};
  if (paginationOptions?.page) {
    params.page = paginationOptions.page;
  }
  if (paginationOptions?.perPage) {
    params.perPage = paginationOptions.perPage;
  }

  logger.log(`📞 Fetching messages for conversation ${id}:`, params);

  return axios.get(`${API_ENDPOINT}/whatsapp/conversation/${id}`, {
    headers: obj,
    ...(Object.keys(params).length > 0 && { params }) // Only add params if they exist
  });
};

export const assignConversation = (id: string, body: any) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.put(`${API_ENDPOINT}/whatsapp/conversation/${id}/assign`, body, {
    headers: obj,
  });
};

export const sendMessageToLead = (data: any) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.post(`${API_ENDPOINT}/whatsapp/send`, data, {
    headers: obj,
  });
};

export const updateProfile = (data: any) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.put(`${API_ENDPOINT}/whatsapp/profile`, data, {
    headers: obj,
  });
};

export const getWhatsappProfile = () => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get(`${API_ENDPOINT}/whatsapp/profile`, {
    headers: obj,
  });
};

export const deregisterWaba = (phoneNumberId?: string) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
    "token-check-disable": "true",
  };

  const body = phoneNumberId ? { phoneNumberId } : {};

  return axios.post(`${API_ENDPOINT}/whatsapp/deregister`, body, {
    headers: obj,
  });
};

export const downloadChatMedia = (data: any) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
    "content-type": "multipart/form-data",
  };
  return axios.post(`${API_ENDPOINT}/whatsapp/download-media`, data, {
    headers: obj,
    // responseType: "blob",
    responseType: "arraybuffer",
  });
};

export const uploadMedia = (data: any) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
    "content-type": "multipart/form-data",
  };
  return axios.post(`${API_ENDPOINT}/whatsapp/upload-media`, data, {
    headers: obj,
  });
};

export const deleteChat = (id: string) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.delete(`${API_ENDPOINT}/whatsapp/conversation/${id}`, {
    headers: obj,
  });
};

// TODO: WhatsApp Conversations Feature - API service for getting conversations by lead ID
// Used by LeadCommunicationPopup component (currently commented out)
export const getConversationsByLeadId = (leadId: string) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  logger.log(`📞 Fetching conversations for lead ${leadId}`);

  return axios.get(`${API_ENDPOINT}/whatsapp/conversation`, {
    headers: obj,
    params: {
      lead: leadId,
      page: 1,
      perPage: 15
    }
  });
};

/**
 * Block or unblock a WhatsApp contact
 * @param leadId - The lead ID to block/unblock
 * @param isBlocked - true to block, false to unblock
 * @param phoneNumberId - The phone number ID associated with the business WhatsApp account
 */
export const blockUnblockContact = (leadId: string, isBlocked: boolean, phoneNumberId: string) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
    "token-check-disable": "true",
  };

  const data = {
    lead: leadId,
    isBlocked: isBlocked,
    phoneNumberId: phoneNumberId,
  };

  logger.log(`${isBlocked ? '🚫 Blocking' : '✅ Unblocking'} contact:`, { leadId, phoneNumberId });

  return axios.post(`${API_ENDPOINT}/whatsapp/block-unblock-contact`, data, {
    headers: obj,
  });
};
